var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSiteStaffWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-37.5%",
    width: "175.0%",
    height: "175.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-263.000000, -975.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(283.000000, 987.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F25643",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-3",
    filter: "url(#filter-3)",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1533558,20.400701 C23.8851197,19.1688008 22.3784801,18.2091109 20.7259333,17.580549 C23.0301379,15.959772 24.5455645,13.1909446 24.5455645,10.0439358 C24.5455645,5.05194257 20.7205307,1 15.9959656,1 C11.2714006,1 7.4463668,5.04924128 7.4463668,10.0466371 C7.4463668,13.1909446 8.95909203,15.959772 11.2632967,17.5832503 C9.61088692,18.2120852 8.10429973,19.1717417 6.83587412,20.4034023 C5.65000559,21.5460501 4.69644844,22.9156067 4.02652727,24.4418384 C3.34653618,26.0162166 2.99715344,27.7134812 3,29.4284291 C3,30.1361684 3.54569675,30.7142455 4.21561792,30.7142455 L27.7844172,30.7142455 C28.4543384,30.7142455 29,30.1361684 29,29.4284291 C29,27.696899 28.6488316,26.0166935 27.9627027,24.4418384 C27.3010909,22.9231675 26.3464214,21.5499122 25.1533558,20.400701 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSiteStaffWarning);
export default __webpack_public_path__ + "static/media/img_site_staff_warning.0c9c75dd854e61b09d1ab6919fa0f551.svg";
export { ForwardRef as ReactComponent };